export default "__VITE_ASSET__DK9s5Tf3__"